import { ProspectStatusHistory } from '../../../types/api/endpoints/prospect/prospect.types';
import { PROSPECT_ENDPOINTS } from '../../../utils/api/endpoints/prospectEndpoints';

const PREFIX = '[prospectStatusHistoryQuery]';

export const prospectStatusHistoryQuery = async (prospectId: number) => {
  console.log(PREFIX, `Fetching prospectStatusHistory infos...`);
  const response = await PROSPECT_ENDPOINTS.getStatusHistory(prospectId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received prospectStatusHistory infos.`);
  return json as ProspectStatusHistory[];
};
